import React from 'react';
import PageTitle from '../PageTitle';
import { doRequest, AjaxRequest } from '../../helper';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import Moment from 'moment';
import $ from 'jquery';

var graph_count = [];
var e_date;
export default class PostCount extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			items: {},
			response: null,
			limit: 500,
			page: 1,
			currentPage: 1,
			searchText: '',
			issearch: false,
			random: 0,
			filter: '',
			totalCount: 0,
			graph_count: [],
			endDate : Moment(),
			startDate :  Moment().subtract(5, 'days')

		}
		this.handleChange1 = this.handleChange1.bind(this);
		this.filterDate = this.filterDate.bind(this)
		this.handleChangeEnd = this.handleChangeEnd.bind(this)
		this.getGraphData = this.getGraphData.bind(this);
		this.getGraph = this.getGraph.bind(this);

	}
	componentDidMount() {
		var ref = this;
		this.filterDate(ref);
	}
	componentWillReceiveProps(nextProps) {
		var ref = this;
		this.filterDate(ref);
		//	this.filterDate(ref);
	}

	handleChange1(date) {
		this.setState({
			startDate: date
		});
	}
	handleChangeEnd(date) {		
		this.setState({
			endDate: date
		});
	}


	 filterDate(ref) {
	
		var graphwisedate = [];
		graph_count = [];
		$("#container").html("");
		var startDate = ref.state.startDate
		var endDate = ref.state.endDate
		e_date = ref.state.endDate;
		if (startDate == undefined && endDate == undefined) {


			startDate = Moment().subtract(5, 'days'),
				endDate = Moment()

		}
		var getDates = function (startDate, endDate) {
			var dates = [],
				currentDate = startDate,
				addDays = function (days) {
					var date = new Date(this.valueOf());
					date.setDate(date.getDate() + days);
					return date;
				};
			while (currentDate <= endDate) {
				dates.push(currentDate);
				currentDate = addDays.call(currentDate, 1);
			}
			return dates;
		};
		var dates = getDates(startDate, endDate);
		dates.forEach(function (date) {
			graphwisedate.push(date);
		});
		if (e_date == graphwisedate[1]) {
			var c_date = graphwisedate[0]
			var c_date1 = graphwisedate[1]
			graphwisedate.splice(0, 1)
			this.getGraphData(c_date, c_date1, ref)
			this.getGraph();

		}
		else {
			for (var i = 0; i <= graphwisedate.length; i++) {
				var c_date = Moment(graphwisedate[0]).format("YYYY-MM-DD")
				//var c_date1 = Moment(graphwisedate[1]).format("YYYY-MM-DD")
				graphwisedate.splice(0, 1)
				
				 this.getGraphData(c_date+"T00:00:00.000Z", c_date+"T23:59:59.000Z", ref)
			//	console.log(c_date, c_date1)

				i = 0;
				// if (i+1==graphwisedate) {
				// 	this.getGraph();

				// }


			}
		}

	}
	getGraphData(sdate, edate, ref) {
		if (edate == undefined) {
			edate = Moment(sdate).add(1, 'days')
		}
		if (sdate == undefined) {
			sdate = Moment(edate).subtract(1, 'days')
		}
		var payload = {
			'action': 'data-graph',
			'module': 'Sampark',
			'model': 'post',
			'data': {
				'direction': 'desc',
				'status': "enabled",
				"startdate": sdate,
				"enddate": edate
			}
		}
		var request = AjaxRequest(payload);
		request.done(function (response) {
			try {
				console.log(response.data)
				response = response.data;
				graph_count.push(response);
				// console.log(graph_count)
				ref.getGraph();
			} catch (ex) {

			}
		})

	}
	getGraph() {
		$("#loader").css({ 'display': 'block' });
		var getdates = [];
		var postcount = [];
		console.log(graph_count)


		var graph_cunt = graph_count.sort(function (a, b) {
			var dateA = new Date(a.responsedate), dateB = new Date(b.responsedate)
			return dateA - dateB //sort by date ascending
		})
		console.log(graph_cunt)
		for (var i = 0; i < graph_cunt.length; i++) {
			console.log(i);
			getdates.push(graph_cunt[i]["responsedate"])
			postcount.push(graph_cunt[i]["Count"])
		}
		$("#loader").css({ 'display': 'none' });

		window.Highcharts.chart('container', {
			chart: {
				type: 'line'
			},
			title: {
				text: 'Total User Post Count'
			},

			xAxis: {
				categories: getdates
			},
			yAxis: {
				title: {
					text: 'Count'
				}
			},
			plotOptions: {
				line: {
					dataLabels: {
						enabled: true
					},
					enableMouseTracking: false
				}
			},
			series: [{
				name: 'Total Count',
				data: postcount
			}]
		});


	}

	render() {

		return (
			<div>
				<PageTitle title="Sampark Abhiyan" bread="Sampark Abhiyan / Post Count" />
				<div className="wrapper wrapper-content">
					<div className="wrapper wrapper-content">

						<div className="row">
							<div style={{ 'display': 'flex', 'margin-bottom': '50px', 'justify-content':'center' }}>
								<DatePicker 
									selected={this.state.startDate ? this.state.startDate : Moment().subtract(5, 'days')}
									selectsStart
									startDate={this.state.startDate}
									endDate={this.state.endDate}
									onChange={this.handleChange1}
								/>
								<div style={{  'height':'35px', 'padding-left': '10px'}}>
									<DatePicker 
										selected={this.state.endDate ? this.state.endDate : Moment()}
										selectsEnd
										startDate={this.state.startDate}
										endDate={this.state.endDate}
										onChange={this.handleChangeEnd}
									/>
								</div>
								<input type="button" style={{ 'margin-left': '10px' }} className="span2 btn btn-primary" value="filter" onClick={() => { this.filterDate(this) }} />
							</div>
							<div id="container"></div>
						</div>
					</div>
				</div>
			</div>);
	}
}


// WEBPACK FOOTER //
// ./src/Components/Sampark/user.jsx